// This file was AUTO-GENERATED by the Typewriter Visual Studio plugin base on the Constants.tst template. 
// !!Do not modify this file or change may be lost!!
/* eslint-disable */
export default class Dr2AmendedIndicators {
    public static readonly ORIGINAL: string = 'O';
    public static readonly AMENDED: string = 'A';
    public static readonly ADJUSTED: string = 'J';
    public static readonly DELETED: string = 'D';
}
